import React, { useCallback, useEffect, useState } from "react";

import { getAdminCourses } from "services";

import { useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminTable, Button, Col, MainPage, Row } from "components";

export const Courses = () => {
  const [loading, setLoading] = useState(true);
  const [courses, setCourses] = useState([]);
  const signal = useCancelAsyncOnUnmount()();

  const loadCourses = useCallback(() => {
    getAdminCourses({
      signal,
    })
      .then((res) => {
        setCourses(res.length > 0 ? res : []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  useEffect(() => {
    loadCourses();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline={`${courses.length} courses`}
        description="View, update or add new courses here."
        extra={
          <Button size="small" type="secondary" href="/course/add">
            Add
          </Button>
        }
      />
      <Row>
        <Col>
          <AdminTable
            dataSource={courses}
            config={{
              actions: [
                {
                  icon: "tabler/edit",
                  route: "/course/update/",
                  tooltip: "Edit this course",
                },
              ],
              exclude: ["teacherName", "teacherImage", "teacherDescription", "requirements", "methods", "learnings", "image", "description"],
            }}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
